export const SUBSCRIPTION_TYPE = {
  general: 'general',
  basic: 'basic',
  premium: 'premium',
  premium_plus: 'premium_plus',
}

export const AVATAR_STYLE = {
  my: 'my',
  other: 'other',
  traveling: 'traveling',
}
